import { IParameter } from "../types";
import { buildFetch, buildRequestBody } from "../utils";
import { getParamsGET_FROM_OR_TO, getParamsGET_STOPPOINT_JSON_SHIPPING, getParamsGET_STOPS_JSON } from "./params";
import { IGetFromOrToResponse, IGetParamsGET_FROM_OR_TO, IGetParamsGET_STOPPOINT_JSON_SHIPPING, IGetParamsGET_STOPS_JSON, IResponseGET_STOPPOINT_JSON_SHIPPING, IResponseGetBusStations } from "./types";

const apiBusStations = {
    /** Получить все остановки в нас пункте */
    async get(params: IGetParamsGET_STOPS_JSON): Promise<IResponseGetBusStations> {
        try {
            const parameters: IParameter[] = getParamsGET_STOPS_JSON(params);
            if (!params.NCITY_ID) {
                throw new Error("NCITY_ID is a required parameter");
            }
            const body = buildRequestBody({ parameters, object_name: "GET_STOPS_JSON" });
            const response = await buildFetch({ body });
            return response;
        } catch (error) {
            console.error('Error fetching bus stations:', error);
            throw new Error('Failed to fetch bus stations. Please try again later.');
        }
    },

    /** Получить все остановки куда или откуда можно уехать с текущего нас пункта или остановки  */
    async getShipping(params: IGetParamsGET_STOPPOINT_JSON_SHIPPING): Promise<IResponseGET_STOPPOINT_JSON_SHIPPING> {
        try {
            const parameters: IParameter[] = getParamsGET_STOPPOINT_JSON_SHIPPING(params);
            if (!params.NLOCALITY_ID) {
                throw new Error("NLOCALITY_ID is a required parameter");
            }
            const body = buildRequestBody({
                parameters,
                object_name: "GET_STOPPOINT_JSON_SHIPPING",
                NCITY_ID: params.NLOCALITY_ID
            });
            const response = await buildFetch({ body });
            return response;
        } catch (error) {
            console.error('Error fetching shipping:', error);
            throw new Error('Failed to fetch shipping. Please try again later.');
        }
    },

     /** Получить все остановки или нас пункты куда или откуда можно уехать с текущего нас пункта или остановки  */
    async getStaitionsOrCityShipping(params: IGetParamsGET_FROM_OR_TO): Promise<IGetFromOrToResponse> {
        try {
            const parameters: IParameter[] = getParamsGET_FROM_OR_TO(params);
            // if (!params.NLOCALITY_ID_FROM) {
            //     throw new Error("NLOCALITY_ID is a required parameter");
            // }
            const body = buildRequestBody({
                parameters,
                object_name: "GET_FROM_OR_TO",
                NCITY_ID: ""
            });
            const response = await buildFetch({ body });
            return response;
        } catch (error) {
            console.error('Error fetching shipping:', error);
            throw new Error('Failed to fetch shipping. Please try again later.');
        }
    }
};

export default apiBusStations;